const TIPI_CONSERVAZIONE = {
  "Armadio Refrigerato": { min: 0, max: 4, metodo: "frigo" },
  "Cella Frigorifera": { min: 0, max: 4, metodo: "frigo" },
  "Tavolo Refrigerato": { min: 0, max: 4, metodo: "frigo" },
  "Frigo Vetrina": { min: 0, max: 8, metodo: "frigo" },
  "Abbattitore": { min: -40, max: 3, metodo: "frigo" },
  "Cantina Vino": { min: 10, max: 18, metodo: "temp_ambiente" },
  "Congelatore": { min: -25, max: -18, metodo: "congelatore" },
};

export const nomeMetodo = (metodo) => ({
  fresco: "Frigo", frigo: "Frigo", temp_ambiente: "Temp. ambiente",
  congelatore: "Congelatore", abbattitore: "Abbattitore",
})[metodo] || "Da scegliere";

export const metodoDaTipologia = (tipologia) => TIPI_CONSERVAZIONE[tipologia]?.metodo || null;

// Il range effettivo ha la precedenza sul nome della tipologia. Se ricade tra
// freddo e ambiente, non preselezionare alcun metodo.
export const metodoDaFrigo = (frigo) => {
  if (!frigo || frigo.temperatura_min == null || frigo.temperatura_max == null ||
      String(frigo.temperatura_min).trim() === "" || String(frigo.temperatura_max).trim() === "") return null;
  const min = Number(frigo.temperatura_min);
  const max = Number(frigo.temperatura_max);
  if (!Number.isFinite(min) || !Number.isFinite(max)) return null;
  const lower = Math.min(min, max);
  const upper = Math.max(min, max);
  const tipo = frigo.tipologia?.trim().toLowerCase();
  // Abbattitore -40/+3 è FRIGO per la tabella concordata, non congelatore.
  if (tipo === "abbattitore" && lower === -40 && upper === 3) return "frigo";
  // Un armadio con limiti realmente sottozero non diventa FRIGO solo per nome.
  if (upper <= -18 || (tipo === "negativo" && upper <= -15 && lower < 0)) return "congelatore";
  if (lower >= 10 && upper <= 18) return "temp_ambiente";
  if (lower >= 0 && upper <= 8) return "frigo";
  return null;
};

export const gruppoConservazione = (lotto) => {
  const stato = lotto.stato || "fresco";
  if (stato === "fresco") return lotto.metodo_conservazione === "temp_ambiente" ? "temp_ambiente" : "frigo";
  if (stato === "congelato" && lotto.metodo_congelamento === "abbattitore") return "abbattuto";
  return stato;
};

export const frigoDellaPosizione = (posizione, frigoriferi = [], localeId) =>
  frigoriferi.find(frigo => frigo.id === posizione && (!localeId || frigo.locale_id === localeId));

export const avvisoConservazione = (posizione, metodo, frigoriferi = [], localeId) => {
  if (!posizione || !metodo) return "";
  const frigo = frigoDellaPosizione(posizione, frigoriferi, localeId);
  if (!frigo) return ""; // Posizioni storiche senza tipologia: nessuna deduzione.
  const previsto = metodoDaFrigo(frigo);
  if (!previsto) return `La tipologia o il range di temperatura di «${frigo.nome}» non corrispondono ai valori proposti. Verifica la scelta.`;
  const invertiti = Number(frigo.temperatura_min) > Number(frigo.temperatura_max);
  if (previsto !== metodo) return `«${frigo.nome}» ha limiti compatibili con ${nomeMetodo(previsto)}, ma hai scelto ${nomeMetodo(metodo)}.${invertiti ? " I limiti minimo e massimo sono anche invertiti." : ""} Puoi cambiare scelta o continuare comunque.`;
  if (invertiti) return `I limiti minimo e massimo di «${frigo.nome}» sono invertiti. Verifica le temperature registrate.`;
  return "";
};